import { render, staticRenderFns } from "./take-over-assign-modal.vue?vue&type=template&id=39ef6490&"
import script from "./take-over-assign-modal.vue?vue&type=script&lang=js&"
export * from "./take-over-assign-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "take-over-assign-modal.vue"
export default component.exports